(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kina-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(e){if(e.target.id!=='KinaVariant')return;const option=e.target.selectedOptions[0],add=document.getElementById('KinaAdd');document.getElementById('KinaPrice').textContent=option.dataset.price;add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;const image=document.getElementById('KinaMainImage');if(option.dataset.image&&image){image.removeAttribute('srcset');image.src=option.dataset.image;}const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();
})();
